'use client';

import { createFileRoute } from '@tanstack/react-router';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import LogsTab from 'src/parts/tabs/LogsTab';
import { getGroupLogs } from 'src/api/admin/logs';
import { startOfDay, subMonths, endOfDay } from 'date-fns';

export const Route = createFileRoute('/_admin/groups/$groupId/logs')({
	validateSearch: (search: Record<string, unknown>) => {
		const now = new Date();
		return {
			from: (search.from as string) || startOfDay(subMonths(now, 1)).toISOString(),
			until: (search.until as string) || endOfDay(now).toISOString(),

			page: (search.page as number) || undefined,
			sort: (search.sort as string) || undefined,
		};
	},
	loaderDeps: ({ search }) => search,
	loader: async ({ params, deps }) => {
		const logs = await getGroupLogs(params.groupId, {
			from: deps.from,
			until: deps.until,
			page: deps.page,
			sort: deps.sort,
		});
		return { logs };
	},
	component: LogsPage,
});

function LogsPage() {
	const { groupId } = Route.useParams();
	const searchParams = Route.useSearch();
	const queryClient = useQueryClient();
	const { logs: initialLogs } = Route.useLoaderData();

	const { data: logs, refetch: refetchLogs } = useQuery({
		queryKey: ['group-logs', groupId, searchParams.from, searchParams.until, searchParams.page, searchParams.sort],
		queryFn: () =>
			getGroupLogs(groupId, {
				from: searchParams.from,
				until: searchParams.until,
				page: searchParams.page,
				sort: searchParams.sort,
			}),
		initialData: initialLogs,
	});

	const handleReload = () => {
		refetchLogs();
	};

	return <LogsTab showFilter={false} logs={logs} logType="GroupLog" onReload={handleReload} />;
}
